<template>
  <div class="login-title-box"
      :class="{'login-title-active': selected}"
      @click="onClick">
    <i style="font-size: 24px"/>
    <div class="login-title">{{title}}</div>
    <div class="login-title-bottom" v-show="selected"/>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
	selected: boolean,
	title: string;
}>()

const emits = defineEmits(['selected'])
const onClick = () => {
  emits('selected')
}

</script>
<style lang="scss" scoped>
.login-title-box {
  color: #909499;
  height: 100%;
  display: flex;
  margin: auto;
  position: relative;
  padding-top: 17px;
  padding-bottom: 17px;
  .login-title{
    font-size: 18px;
    color: #303133;
    font-weight: 600;
  }

  &:hover{
    cursor: pointer;
  }
}

.login-title-active {
  color: #3D8EFF;
  .login-title{
    color: #3D8EFF;
  }
}

.login-title-bottom {
  background: #3D8EFF;
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: 0;
}
</style>
